/* eslint-disable */
import LazySizes from 'lazysizes';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
/* eslint-enable */
import loadingAttributePolyfill from 'loading-attribute-polyfill';

import { onDocumentReady } from './utils';

// Components
import Menu from '@src/components/menu';
import ToggleGrid from '@src/components/toggle-grid';
import Links from '@src/components/links';
import ScrollTrigger from '@src/components/scroll-trigger';
import FaviconTheme from '@src/components/favicon-theme';

onDocumentReady(() => {
  new Links();
  new ScrollTrigger();
  new FaviconTheme();

  if (window.ads_blocked) {
    document.body.classList.add('ads-blocked');
  }

  const MENU_CLASS = '.js--menu';
  if (document.querySelector(MENU_CLASS)) {
    new Menu(MENU_CLASS);
  }

  if (process.env.NODE_ENV === 'development') {
    new ToggleGrid();
  }

  if (document.querySelector('.js-modal-gallery')) {
    import(/* webpackChunkName: "modal-gallery" */ '@src/components/modal-gallery').then(module => {
      const ModalGallery = module.default;
      new ModalGallery();
    });
  }

  if (document.querySelector('.js-article-meta')) {
    import(/* webpackChunkName: "article-meta" */ '@src/components/article-meta').then(module => {
      const ArticleMeta = module.default;
      new ArticleMeta();
    });
  }

  if (document.querySelector('.js-faq')) {
    import(/* webpackChunkName: "faq" */ '@src/components/faq').then(module => {
      const FAQ = module.default;
      new FAQ();
    });
  }

  if (document.querySelector('.js-hang-punc')) {
    import(/* webpackChunkName: "hang-punctuation" */ '@src/components/hang-punctuation').then(
      module => {
        const HangPunctuation = module.default;
        new HangPunctuation();
      },
    );
  }

  if (document.querySelector('.js-timezone')) {
    import(/* webpackChunkName: "timezone" */ '@src/components/timezone').then(module => {
      const Timezone = module.default;
      new Timezone();
    });
  }

  if (document.querySelector('.js-founder-wall')) {
    import(/* webpackChunkName: "founder-wall" */ '@src/components/founder-wall').then(module => {
      const FounderWall = module.default;
      new FounderWall();
    });
  }

  if (document.querySelector('.js-republisher')) {
    import(/* webpackChunkName: "republisher" */ '@src/components/republisher').then(module => {
      const Republisher = module.default;
      new Republisher();
    });
  }

  if (document.querySelector('.js-donor-wall')) {
    import(/* webpackChunkName: "donor-wall" */ '@src/components/donor-wall').then(module => {
      const DonorWall = module.default;
      new DonorWall();
    });
  }

  if (document.querySelector('.js-membership') || document.querySelector('.js-donate-button')) {
    if (
      process.env.NODE_ENV === 'development' ||
      document.location.host === 'staging.19thnews.org'
    ) {
      window.fundraiseup_livemode = false;
    }

    import(/* webpackChunkName: "fundraise-up" */ '@src/components/fundraise-up').then(module => {
      const FundraiseUp = module.default;
      new FundraiseUp();
    });
  }

  if (document.querySelector('.js-patron-wall')) {
    import(/* webpackChunkName: "patron-wall" */ '@src/components/patron-wall').then(module => {
      const PatronWall = module.default;
      new PatronWall();
    });
  }

  if (document.querySelector('.js-newsletter-form')) {
    import(/* webpackChunkName: "newsletter" */ '@src/components/newsletter').then(module => {
      const Newsletter = module.default;
      const newsletter = new Newsletter();

      // We can set a callback to call when someone solves a captcha, by
      // putting it in the data-callback field of the recaptcha div.  However,
      // the callback must have a globally-defined name.  So we'll set that
      // here, and have it call the callback on the newsletter we just
      // instantiated.
      window.newsletterRecaptchaCallback = Newsletter.prototype.recaptchaSolvedCallback.bind(newsletter);
    });
  }

  if (document.querySelector('.js-site-banner')) {
    import(/* webpackChunkName: "site-banner" */ '@src/components/site-banner').then(module => {
      const SiteBanner = module.default;
      new SiteBanner();
    });
  }

  if (document.querySelector('.summit-topbar')) {
    import(/* webpackChunkName: "site-banner" */ '@src/components/summit-topbar').then(module => {
      const SummitTopbar = module.default;
      new SummitTopbar();
    });
  }

  if (document.querySelector('.js-register')) {
    import(/* webpackChunkName: "register" */ '@src/components/register').then(module => {
      const Register = module.default;
      new Register();
    });
  }

  if (document.querySelector('.js-about')) {
    import(/* webpackChunkName: "register" */ '@src/components/about').then(module => {
      const About = module.default;
      new About();
    });
  }

  if (document.querySelector('.js-loadmore')) {
    import(/* webpackChunkName: "register" */ '@src/components/loadmore').then(module => {
      const Loadmore = module.default;
      new Loadmore();
    });
  }

  if (document.querySelector('.js-summit-form')) {
    import(/* webpackChunkName: "register" */ '@src/components/summit-form').then(module => {
      const SummitForm = module.default;
      new SummitForm();
    });
  }

  if (document.querySelector('.js-mobile-newsletter-cta')) {
    import(
      /* webpackChunkName: "mobile newsletter" */ '@src/components/mobile-newsletter-cta'
    ).then(module => {
      const MobileNewsletterCTA = module.default;
      new MobileNewsletterCTA();
    });
  }

  if (document.querySelector('.js-search')) {
    import(/* webpackChunkName: "search" */ '@src/components/search-form').then(module => {
      const SearchForm = module.default;
      new SearchForm();
    });
  }

  if (document.querySelector('.js-membership-accordion')) {
    import(/* webpackChunkName: "membership accordion" */ '@src/components/membership-accordion').then(module => {
      const MembershipAccordion = module.default;
      new MembershipAccordion();
    });
  }

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});
